/**
 * ENUM
 * Determina tipos de acao para lidar com conflitos durante importacao.
 */
export enum ImportUpdateBehaviorEnum {
    SKIP = 'SKIP',                  // Pular registro repetido
    UPDATE_BLANK = 'UPDATE_BLANK',  // Completar campos vazios do registro pre-existente
    OVERWRITE = 'OVERWRITE',        // Sobrescrever
}